import { useLazyQuery } from '@apollo/client'

import {
  CompleteSignupNudgeViewerQuery,
  CompleteSignupNudgeViewerQueryVariables,
} from './__generated__/query.graphql'
import { COMPLETE_SIGNUP_NUDGE_VIEWER_QUERY } from './query'

export type CompleteSignupNudgeViewerData = NonNullable<
  CompleteSignupNudgeViewerQuery['root']['viewer']
>

export function useNudgeViewer() {
  const [fetchViewer, { data, loading, called }] = useLazyQuery<
    CompleteSignupNudgeViewerQuery,
    CompleteSignupNudgeViewerQueryVariables
  >(COMPLETE_SIGNUP_NUDGE_VIEWER_QUERY)
  return { fetchViewer, viewer: data?.root.viewer ?? null, loading, called }
}
